import {SnackbarProvider} from 'notistack'
import {FC, useEffect, useState} from 'react'
import {Row} from 'react-bootstrap'
import {KTCard} from '../../../../../../../_metronic/helpers'
import {KTableLoading} from '../../../../../components/UI'
import {useAuth} from '../../../../../hooks/useAuth'
import {CheckingModel} from '../../../models/ckecking.model'
import {getCheckingService2} from '../../../services/checking.service'
import CheckoutCardApp from './CheckoutCardApp'

const CheckoutListApp: FC = () => {
  const {user} = useAuth()
  const [loading, setLoading] = useState<boolean>(false)
  const [checkin, setCheckin] = useState<CheckingModel | null>(null)
  const [isChecked, setIsChecked] = useState<boolean>(false)

  const getChekings = async () => {
    try {
      setLoading(true)
      const {data: response} = await getCheckingService2({
        pageNumber: 1,
        size: 10,
        StatusCode: '3',
        ReservasDelDia: true,
        UsuarioId: user.id,
        // UsuarioId: user.id,
      })
      if (!response.error) {
        if (response.data.length === 0) {
          const {data: response2} = await getCheckingService2({
            pageNumber: 1,
            size: 10,
            StatusCode: '4',
            ReservasDelDia: true,
            UsuarioId: user.id,
          })
          if (!response2.error) {
            if (response2.data.length !== 0) {
              setIsChecked(true)
              setCheckin(response2.data[0])
            }
          }
        } else {
          setCheckin(response.data[0])
        }
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getChekings()
  }, [])
  return (
    <div className='m-5'>
      {loading ? (
        <KTableLoading title='Cargando' />
      ) : checkin ? (
        <Row style={{padding: '10px'}}>
          <CheckoutCardApp checkin={checkin} isChecked={isChecked} getCheckings={getChekings} />
        </Row>
      ) : (
        <Row style={{height: '200px'}}>
          <KTCard>
            <div className='d-flex justify-content-center align-items-center h-100'>
              <h5 style={{fontSize: '18px'}}>No se encontraron reservas asignadas</h5>
            </div>
          </KTCard>
        </Row>
      )}
      <SnackbarProvider />
    </div>
  )
}

export default CheckoutListApp
